import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { base_url } from 'constant/url';
import Toast from 'utils/Toast';


const baseQueryWithErrorHandling = async (args, api, extraOptions) => {
    const rawBaseQuery = fetchBaseQuery({
        baseUrl: base_url,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.common?.user_token;
            if (token?.accessToken) {
                headers.set('Authorization', `Bearer ${token?.accessToken}`);
            }
            return headers;
        },
    });


    const performRawLogout = async (api, extraOptions) => {
        const state = api.getState();
        const deviceId = state?.common?.device_id;
        const userId = state?.common?.user_data?._id;
    
        try {
            await rawBaseQuery(
                {
                    url: '/user/auth/logout',
                    method: 'POST',
                    body: { deviceId, userId },
                },
                api,
                extraOptions
            );
        } catch (err) {
            console.error('Logout failed in baseQuery:', err);
        }
    };

    try {
        const result = await rawBaseQuery(args, api, extraOptions);
        
        if (result.error) {
            const { status } = result.error;
            if (status === 401 || status === 403) {
                await performRawLogout(api, extraOptions);
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = '/';
            }
            return { error: result.error };
        }
        return result;
    } catch (error) {
        Toast("e", 'An unexpected error occurred.');
        return { error: 'An unexpected error occurred.' };
    }
};

export const baseApi = createApi({
    reducerPath: 'baseApi',
    baseQuery: baseQueryWithErrorHandling,
    keepUnusedDataFor: 60,
    endpoints: () => ({}),
});
